import {
  Box,
  Typography,
  Button,
  InputAdornment,
  TextField,
} from "@mui/material"
import { Link, useLocation, useNavigate } from "react-router-dom"
import PqrCard from "../../components/pqrCard"
import useStyles from "./style"
import { icons, lists } from "../../utils"
import { useState } from "react"
import { isEmpty } from "../../validators/validator"

const SearchPqr = () => {
  const classes = useStyles()
  let location = useLocation()
  let query = new URLSearchParams(location.search)
  let ticketId = query.get("num_radicado")

  const navigate = useNavigate()
  const [ticketSearched, setTicketSearched] = useState(
    ticketId ? ticketId : undefined
  )
  const handleKeyPress = (e) => {
    console.log(e.target.value)
    if (e.key === "Enter" && isEmpty(e.target.value) === false) {
      setTicketSearched(e.target.value)
      navigate(`/searchpqrsf?num_radicado=${e.target.value}`)
    }
  }
  return (
    <Box className={classes.body}>
      <Box className={classes.imgContainer}></Box>
      <Box className={classes.listContainer}>
        <Box className={classes.listBody}>
          <Box className={classes.listHeader}>
            <Box className={classes.titleContainer}>
              <Typography variant="h1" className={classes.title}>
                {lists.searchPqr.title}
              </Typography>
            </Box>
            <Box className={classes.subTitleContainer}>
              <Typography variant="h3" className={classes.subTitle}>
                {lists.searchPqr.subTitle}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.searchBar}>
            <TextField
              label="Buscar"
              name="searchId"
              defaultValue={ticketSearched}
              onKeyPress={handleKeyPress}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9.]/, "")
                  .replace(/(\..*)\./g, "$1")
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {icons("search")}
                  </InputAdornment>
                ),
              }}
              sx={{ width: 360 }}
              variant="outlined"
              className={classes.search}
            />
          </Box>
          <Box className={classes.list}>
            <PqrCard ticketId={ticketSearched} />
          </Box>
          <Box className={classes.buttonContainer}>
            <Button
              variant="contained"
              className={classes.inputButton}
              component={Link}
              to={"/"}
            >
              {lists.searchPqr.button}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SearchPqr
